import constate from "constate"
import { useState } from "react"
import { RecurringScheduleEnum } from "__generated__/globalTypes"
import { BillingCycleSelectFragment } from "__generated__/BillingCycleSelectFragment"

const possibleCycles = ["Pay monthly", "Pay quarterly", "Pay yearly"] as const
type BillingCycle = typeof possibleCycles[number]

const [BillingCycleSelectProvider, useBillingCycleSelect] = constate(() => {
    const [billingCycle, setBillingCycle] =
        useState<BillingCycle>("Pay monthly")

    const getItem = (partnershipTier: BillingCycleSelectFragment) => {
        switch (billingCycle) {
            case "Pay yearly":
                return partnershipTier.items.edges.find(
                    edge =>
                        edge?.node?.recurringEnum === RecurringScheduleEnum.year
                )?.node
            case "Pay quarterly":
                return partnershipTier.items.edges.find(
                    edge =>
                        edge?.node?.recurringEnum ===
                        RecurringScheduleEnum.quarter
                )?.node
            case "Pay monthly":
            default:
                return partnershipTier.items.edges.find(
                    edge =>
                        edge?.node?.recurringEnum ===
                        RecurringScheduleEnum.month
                )?.node
        }
    }

    const showBillingCycle = (partnershipTier?: BillingCycleSelectFragment) =>
        (
            partnershipTier?.items.edges.filter(
                edge =>
                    edge?.node?.recurringEnum !== RecurringScheduleEnum.month
            ) ?? []
        ).length > 0

    return {
        billingCycle,
        setBillingCycle,
        possibleCycles,
        getItem,
        showBillingCycle,
    }
})

export { BillingCycleSelectProvider, useBillingCycleSelect }
